import { TeacherService } from './core/services/teacher.service';
import { StudentService } from 'src/app/core/services/student.service';
import { BaseComponent } from 'src/app/components/base/base.component';
import { takeUntil } from 'rxjs/operators';
import { Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { Component, Inject, Renderer2, Pipe } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CourseService } from '../app/core/services/course.service';
import { Notifications } from './core/models/notifications';
import { BaseService } from './core/services/base.service';

import { MouseService } from './core/services/mouse.service';
import { LogoutFromLMSService } from './core/services/logoutFromLMS.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent extends BaseComponent{
  title = 'LearnyhomeAcademy';
  isMouseFrozen = false;

  dir = true;
  tokenValid = false;

  userFullName: string;
  teacherId: number;
  studentId: number;
  isTeacher: string;

  loader = true;
  studNotifications: Notifications[];
  studNotificationsNo = 0 as number;

  teacherNotifications: Notifications[];
  teacherNotificationsNo = 0 as number;

  profileImg: string;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
    private translate: TranslateService,
    private courseService: CourseService,
    private router: Router,
    private studentService: StudentService,
    private teacherService: TeacherService,
    public baseService:BaseService,
    private mouseService: MouseService,
    private logoutFromLMSService: LogoutFromLMSService
  ) {
    super();
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.loader = false;
    }, 6000);

    this.mouseService.detectMouseFreeze().subscribe(isFrozen => {
      this.isMouseFrozen = isFrozen;
      if (isFrozen) {
        // Handle freeze event, e.g., display a message or trigger an action
        // console.log('Mouse frozen!');
      }
    });


    
    this.isTeacher = localStorage.getItem('isTeacher');
    const token = localStorage.getItem('token');
    if (token) { this.tokenValid = true; }
    else { this.tokenValid = false; }

    this.userFullName = localStorage.getItem('userFullName');
    this.profileImg = localStorage.getItem('profileImg');

    if(this.isTeacher === 'true') {
      var teachId = localStorage.getItem('teacherId');
      this.teacherId = Number(teachId);

      this.teacherService.getTeacherNotification(this.teacherId).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
        (data: any) => {
          this.teacherNotifications = data.result.returnData;
          this.teacherNotificationsNo = this.teacherNotifications.length;
          // console.log(this.teacherNotifications);
        }
      )
    }
    else if(this.isTeacher === 'false') {
      var studtId = localStorage.getItem('studentId');
      this.studentId = Number(studtId);

      this.studentService.getStudentNotification(this.studentId).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
        (data: any) => {
          // console.log(data.result.returnData);
          this.studNotifications = data.result.returnData;
          // console.log(this.studNotifications);
          this.studNotificationsNo = this.studNotifications.length;
        }
      )
    }




    const hamberger = document.querySelector('.hamberger-button');
    const menuLinks = document.querySelector('.popup-mobile-menu');
    if (hamberger && menuLinks) {
      hamberger.addEventListener('click', () => {
        menuLinks.classList.toggle('active');
      });
    }

    const close_button = document.querySelector('.close-button'); 
    if (close_button && menuLinks) {
      close_button.addEventListener('click', () => {
        menuLinks.classList.remove('active');
      });
    }

    const cart = document.querySelector('.rbt-cart-sidenav-activation');
    const side_menu = document.querySelector('.rbt-cart-side-menu');
    if (cart && side_menu) {
      cart.addEventListener('click', () => {
        side_menu.classList.add('side-menu-active');
      });
    }

    var lang = localStorage.getItem('lang');
    if (lang === 'en') {
      localStorage.setItem('lang', 'en');
      var lang = localStorage.getItem('lang');
      this.translate.use(lang);
      this.baseService.isRTL = false;
      document.getElementsByTagName('html')[0].setAttribute('dir', 'ltr');
      this.renderer.addClass(this.document.body, 'rtl');
      this.dir = true;


    } else { 
      localStorage.setItem('lang', 'ar');
      var lang = localStorage.getItem('lang');
      this.translate.use(lang);
      this.baseService.isRTL = true;
      document.getElementsByTagName('html')[0].setAttribute('dir', 'rtl');
      this.renderer.addClass(this.document.body, 'ltr');
      this.dir = false;

    }
    // console.log(lang);
  
  }

  closeNotification() {
    debugger
    const minicart_close_button = document.querySelector('.minicart-close-button'); 
    const side_menu = document.querySelector('.rbt-cart-side-menu');
    if (minicart_close_button && side_menu) {
      minicart_close_button.addEventListener('click', () => {
        side_menu.classList.remove('side-menu-active');
      });
    }
  }

  onActive(){
    window.scroll(0, 0);
  }

  changeLangAR() {
    document.getElementsByTagName('html')[0].setAttribute('dir', 'rtl');
    this.renderer.addClass(this.document.body, 'ltr');

    localStorage.setItem('lang', 'ar');
    let lang : string = localStorage.getItem('lang') as string
    this.translate.use(lang);
    this.dir = false;
  }

  changeLangEn() {
    document.getElementsByTagName('html')[0].setAttribute('dir', 'ltr');
    this.renderer.addClass(this.document.body, 'rtl');
    
    localStorage.setItem('lang', 'en');
    let lang : string = localStorage.getItem('lang') as string
    this.translate.use(lang);
    this.dir = true;
  }

  viewProfile(id) {
    this.router.navigate(['/teacher-profile/edit', this.teacherId])
  }

  viewCourses(id) {
    this.router.navigate(['/teacher-courses/edit', this.teacherId]);
  }

  viewSettings(id) {
    debugger
    this.router.navigate(['/teacher-settings/edit', this.teacherId]);
  }

  logout() {
    debugger
    var userId =  Number(localStorage.getItem('userId'));
    this.logoutFromLMSService.logoutUser(userId).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
      (data: any) => {
        // console.log(data)
      }
    )

    localStorage.removeItem('token');
    localStorage.removeItem('academyToken');
    localStorage.removeItem('studentId');
    localStorage.removeItem('profileImg');
    localStorage.removeItem('userId');
    localStorage.removeItem('isTeacher');
    localStorage.removeItem('teacherId');
    localStorage.removeItem('userFullName');
    localStorage.removeItem('token');


    
    localStorage.clear();
    this.router.navigate(['/home']);

    setTimeout(() => {
      this.router.navigate(['/home']);
    }, 200);
    if (!localStorage.getItem('up')) {
      localStorage.setItem('up', 'no reload');
      location.reload();
    } else {
      localStorage.removeItem('up');
    }
  }

  Search(e) {
    this.courseService.Search(e.target.value).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
      (searchData: any) => {
        // console.log(searchData)
      }
    )
  }


  viewStudProfile(id) {
    this.router.navigate(['/student-profile/edit', this.studentId])
  }

  viewStudCourses(id) {
    this.router.navigate(['/student-courses/edit', this.studentId]);
  }

  viewStudSettings(id) {
    this.router.navigate(['/student-settings/edit', this.studentId]);
  }
  
  viewWishlist(id) {
    this.router.navigate(['/wishlist/edit', this.studentId]);
  }

  ViewPayments(id) {
    this.router.navigate(['/teacher-payments/edit', this.teacherId]);
    const notifySideMenu = document.querySelector('.rbt-cart-side-menu');
    notifySideMenu.classList.remove('side-menu-active');
  }

  viewCart() {
    this.router.navigate(['/cart']);
  }

  showNotificationSide() {
    const notifySideMenu = document.querySelector('.rbt-cart-side-menu');
    notifySideMenu.classList.add('side-menu-active');
  }

  showMobileMenu() {
    const menuLinks = document.querySelector('.popup-mobile-menu');
    menuLinks.classList.add('active');
  }

  hideMobilemenu() {
    const menuLinks = document.querySelector('.popup-mobile-menu');
    menuLinks.classList.remove('active');
  }
}